import React from 'react';
import pluralize from 'pluralize';

import { isTypingTarget } from '../../helpers/links_to_check_flow_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './MergeSheet.scss';

/** Confirms a merge: what moves to the older product, and which product is deleted. */
const MergeSheet = () => {
  const { link, isKeysOpen, answer, closeSheet } = useLinksToCheckContext();
  const { keep, remove, moves } = link.pair;

  const merge = () => answer({ kind: 'merge' });

  useWindowKeydown(e => {
    if (isKeysOpen || isTypingTarget(e.target) || e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key === 'Escape') closeSheet();
    else if (e.key === 'Enter' && e.target?.tagName !== 'BUTTON') merge();
    else return;
    e.preventDefault();
  });

  return (
    <div className='merge-sheet' role='dialog' aria-label='Merge into the older product?'>
      <h3>Merge into the older product?</h3>
      <div className='merge-moves'>
        Moves {pluralize('link', moves.links, true)} and {pluralize('creator pin', moves.pins, true)} to #{keep.id}, then deletes #{remove.id}.
      </div>
      <div className='sheet-footer'>
        <button type='button' className='ltc-btn ghost' onClick={closeSheet}>
          Cancel <span className='ltc-key'>Esc</span>
        </button>
        <button type='button' className='ltc-btn primary' onClick={merge}>
          Merge <span className='ltc-key'>↵</span>
        </button>
      </div>
    </div>
  );
};

export default MergeSheet;
